import React, { Component } from 'react';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Descriptions,
  Form,
  Icon,
  message,
  Modal,
  notification,
  Row,
  Select,
  Spin,
  Switch as MySwitch,
  Table
} from "antd";
import moment from "moment";
import {
  addSpareListToMergeList,
  addToMergeList,
  fetchVoucherByType,
  getSpareInventory,
  getSpareInventoryFilters,
  resetInventorySuccess,
  transferSpare
} from "../../appRedux/actions";
import { connect } from "react-redux";
import axios from 'util/Api';
import { createDebounce } from '../../util/methods';

import './style.css';
import { closingCol, commonCols, inventoryColumns, openingCol, rateAvg } from './inventory-report-util'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

class SpareInventory extends Component {

  state = {
    selectedFromDate: "",
    selectedToDate: "",
    inventories: null,
    selectedLocation: ['All'],
    selectedSubLocation: ['All'],
    selectedSparePart: ['All'],
    selectedSparePartType: ['All'],
    showOpening: false,
    showClosing: false,
    showInward: true,
    showOutward: true,
    rateCalculateFormula: 'avg',
    disableReportButton: false,
    resource: null,
    showResource: true,
    showDetails: false,
    detailsData: null,
    detailsSpare: '',
    detailsSpareId: '',
    detailsSpareTye: '',
    detailsUnit: '',
    reportColumns: [],
    colLoading: false,
    spareDatas: [],
    spareFetching: false,
    showTransferModal: false,
    transferPayload: {},
    hideZeroClosing: false,
    hideZeroTransaction: false,
  };

  spareSearchRequestSeq = 0;

  debouncedFetchSpare = createDebounce((value) => {
    this.fetchSpareFromApi(value);
  }, 350);

  componentDidMount = () => {
    // this.props.resetInventorySuccess();
    this.props.getSpareInventoryFilters();
    this.handleOpenCloseShow();
  };

  componentWillUnmount() {
    if (this.debouncedFetchSpare && this.debouncedFetchSpare.cancel) {
      this.debouncedFetchSpare.cancel();
    }
  }

  fetchData = (payload) => {
    this.props.getSpareInventory(payload);
  };

  handleOpenCloseShow = (isOpen, isClose) => {
    this.setState({
      colLoading: true
    });
    let allColumns = [...inventoryColumns];

    if (isOpen === true) {
      const hasOpenCol = allColumns.filter(col => col.title === 'Opening')
      if (!hasOpenCol || hasOpenCol.length === 0) {
        allColumns.splice(5, 0, openingCol)
      }
    } else {
      allColumns = allColumns.filter(col => col.title !== 'Opening');
    }

    if (isClose === true) {
      const hasCloseCol = allColumns.filter(col => col.title === 'Closing')
      if (!hasCloseCol || hasCloseCol.length === 0) {
        allColumns = allColumns.concat(closingCol)
      }
    } else {
      allColumns = allColumns.filter(col => col.title !== 'Closing')
    }

    this.setState({
      reportColumns: allColumns,
      colLoading: false
    })
  }

  onClickRow = (record) => {
    return {
      onDoubleClick: () => {
        if (record.details) {
          const docs = record.details.map(doc => {
            if (doc && doc.text && doc.text === 'Closing Balance')
              doc.date = this.state.selectedToDate + 'T23:59:59';
            if (doc && doc.text && doc.text === 'Opening Balance')
              doc.date = this.state.selectedFromDate + 'T00:00:01';
            return doc;
          })

          docs.sort((a, b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0));
          let prevOpenQty = 0;
          let prevOpenRate = 0;
          let prevOpenTotal = 0;
          let prevCloseQty = 0;
          let prevCloseRate = 0;
          let prevCloseTotal = 0;
          this.setState({
            showDetails: true,
            detailsData: docs.map((data, index) => {
              if (data && data.text && data.text !== 'Opening Balance') {
                data.openQty = prevCloseQty;
                data.openRate = prevCloseRate;
                data.openTotal = prevCloseTotal;
              } else
                data.openRate = data.openQty === 0 ? 0 : data.openRate;

              prevCloseQty = data.closeQty = data.openQty + data.inQty - data.outQty;
              prevCloseRate = data.closeRate = data.closeQty === 0 ? 0 : rateAvg([data.openRate, data.inRate, data.outRate]);
              prevCloseTotal = data.closeTotal = data.closeQty * data.closeRate;

              return data;
            }),
            detailsSpare: record.sparePart,
            detailsSpareId: record.sparePartId,
            detailsSpareType: record.sparePartType,
            detailsUnit: record.unit,
          });
        }
      },
    };
  }

  handleModalCancel = e => {
    this.setState({
      showDetails: false,
      detailsData: null,
    });
  };

  setRowClassName = (record) => {
    return record.key === this.state.rowId ? record.color : '';
  }

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.form.validateFields((err, values) => {
      if (err) {
      } else {
        if (moment(values.periodFrom).isSameOrBefore(values.periodTo)) {
          const {
            selectedFromDate,
            selectedToDate,
            selectedLocation,
            selectedSubLocation,
            selectedSparePart,
            selectedSparePartType,
            showOpening,
            showClosing,
            showInward,
            showOutward,
            rateCalculateFormula,
          } = this.state;

          this.fetchData({
            selectedFromDate, selectedToDate,
            selectedLocation: selectedLocation.filter(l => l !== 'All'),
            selectedSubLocation: selectedSubLocation.filter(l => l !== 'All'),
            selectedSparePart: selectedSparePart.filter(l => l !== 'All'),
            selectedSparePartType: selectedSparePartType.filter(l => l !== 'All'), showOpening,
            showClosing, showInward, showOutward, rateCalculateFormula
          })
            ;
        } else {
          message.error("Period From couldn't come earlier than Period To!");
        }
      }
    });
  };

  handleSelect = (type, value) => {
    switch (type) {
      case 'periodFrom':
        this.setState({
          selectedFromDate: moment(value).format('YYYY-MM-DD'),
        });
        break;
      case 'periodTo':
        this.setState({
          selectedToDate: moment(value).format('YYYY-MM-DD'),
        });
        break;
      case 'subLocation':
        this.setState({
          selectedSubLocation: value,
        });
        break;
      case 'location':
        this.setState({
          selectedLocation: value,
        });
        break;
      case 'sparePart':
        this.setState({
          selectedSparePart: value
        });
        break;
      case 'sparePartType':
        this.setState({
          selectedSparePartType: value
        });
        break;
      case 'opening':
        this.setState({
          showOpening: value,
        });
        this.handleOpenCloseShow(value, this.state.showClosing);
        break;
      case 'closing':
        this.setState({
          showClosing: value,
        });
        this.handleOpenCloseShow(this.state.showOpening, value);
        break;
      case 'zeroClose':
        this.setState({
          hideZeroClosing: value,
        });
        // this.handleOpenCloseShow(this.state.showOpening, value);
        break;
      case 'zeroTransaction':
        this.setState({
          hideZeroTransaction: value,
        });
        break;
      case 'inward':
        this.setState({
          showInward: value
        });
        break;
      case 'outward':
        this.setState({
          showOutward: value
        });
        break;
      case 'rate':
        this.setState({
          rateCalculateFormula: value
        });
        break;
      default:
    }
  };

  fetchSpareFromApi = async (value) => {
    const requestSeq = ++this.spareSearchRequestSeq;
    this.setState({ spareFetching: true });
    try {
      const response = await axios.get(`/spare-part/search-spares?searchValue=${encodeURIComponent(value)}`);
      if (requestSeq !== this.spareSearchRequestSeq) {
        return;
      }
      this.setState({
        spareDatas: (response && response.data) || [],
        spareFetching: false,
      });
    } catch (error) {
      if (requestSeq !== this.spareSearchRequestSeq) {
        return;
      }
      this.setState({ spareDatas: [], spareFetching: false });
    }
  };

  fetchSpare = (value) => {
    const searchValue = (value || "").toString().trim();
    if (!searchValue || searchValue.length < 2) {
      this.spareSearchRequestSeq += 1;
      if (this.debouncedFetchSpare && this.debouncedFetchSpare.cancel) {
        this.debouncedFetchSpare.cancel();
      }
      this.setState({ spareDatas: [], spareFetching: false });
      return;
    }
    this.debouncedFetchSpare(searchValue);
  };

  canTransferVoucher = (type) => {
    const normalizedType = (type || '').toString().toUpperCase();
    return ['PURCHASE', 'PO', 'ISSUE', 'SPI', 'RECEIPT', 'SRA', 'TRANSFER', 'STA', 'TINV', 'TPW', 'INVOICE']
      .indexOf(normalizedType) >= 0;
  };

  handelVoucherClick = (type, no) => {
    const normalizedType = (type || '').toString().trim().toUpperCase();
    const voucherNo = (no || '').toString().trim();
    if (normalizedType === 'ADJ' && voucherNo.toUpperCase().indexOf('SAV-') === 0) {
      window.open(`/spare-stock-taking-adjustment/${encodeURIComponent(voucherNo)}`, '_blank');
      return;
    }
    this.props.fetchVoucherByType(type, no);
    // this will call an action to fetch the _id for type, then from that action it will redirect to that page
  };

  handelTransferClick = (type, no) => {
    // console.log(type, no);
    this.setState({
      showTransferModal: true,
      transferPayload: { type, no }
    })
    // return <Transfer showModal={true}/>;
  };

  processTransfer = () => {
    const { type, no, spareId } = this.state.transferPayload;
    if (type && no && spareId) {
      this.props.transferSpare(type, no, this.state.detailsSpareId, spareId);
    } else {
      message.error(`Invalid data for transfer!`)
    }
    this.setState({
      showTransferModal: false,
      showDetails: false,
      detailsData: null,
    });
    this.props.resetInventorySuccess();
  };

  handleSelectTransferableSpare = (spareId) => {
    if (spareId) {
      const { type, no } = this.state.transferPayload;
      this.setState({
        transferPayload: { type, no, spareId }
      })
    }
  };

  cancelTransferModal = () => {
    this.setState({
      showTransferModal: false,
    })
  }

  rowSelection = {
    // hideDefaultSelections: true,
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      // console.log(record);
      // this.props.addToMergeList(record, selected);
    },
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      this.props.addSpareListToMergeList(selectedRows);
    },
    getCheckboxProps: record => ({
      disabled: record.location !== 'Total', // Column configuration not to be checked
      record,
    }),
    onSelectAll: (selected, selectedRows, changeRows) => {
      // console.log(selected, selectedRows, changeRows);
    },
    onSelectInvert: (selectedRows) => {
      // console.log(selectedRows);
    },
  };

  openSpareSelectionBox = (selectedRows) => {
    const btn = (
      <Button type="primary" size="small" onClick={() => notification.close(1)}>
        Confirm
      </Button>
    );
    notification.open({
      duration: 0,
      message: 'Notification Title',
      description:
        `Selected records ${selectedRows.length}`,
      onClick: () => {
        console.log('Notification Clicked!');
      },
      btn,
    });
  };

  handelMergeFormOpen = () => {
    // const {match} = this.props;
    this.props.history.push(`spare-part-merge`);
  };

  handleDownload = (data) => {
    if (data && data.length) {
      const tableData = data;
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';
      if (tableData && tableData.length) {
        let arr = [];
        for (let i = 0; i < tableData.length; i++) {
          let obj = {};
          obj.Sno = i + 1;
          obj['Spare Part'] = tableData[i].sparePart || '';
          obj['Spare Type'] = tableData[i].sparePartType || '';
          obj['Unit'] = tableData[i].unit || '';
          obj['Location'] = tableData[i].location || '';
          obj['Sub Location'] = tableData[i].subLocation || '';
          obj['Sub Location'] = tableData[i].subLocation || '';
          obj['Opening'] = tableData[i].openQty || 0;
          obj['Opening Rate'] = tableData[i].openRate || 0;
          obj['Opening Total'] = tableData[i].openTotal || 0;
          obj['Inwards'] = tableData[i].inQty || 0;
          obj['Inwards Rate'] = tableData[i].inRate || 0;
          obj['Inwards Total'] = tableData[i].inTotal || 0;
          obj['Outwards'] = tableData[i].outQty || 0;
          obj['Outwards Rate'] = tableData[i].outRate || 0;
          obj['Outwards Total'] = tableData[i].outTotal || 0;
          obj['Closing'] = tableData[i].closeQty || 0;
          obj['Closing Rate'] = tableData[i].closeRate || 0;
          obj['Closing Total'] = tableData[i].closeTotal || 0;
          arr.push(obj);
        }
        const ws = XLSX.utils.json_to_sheet(arr);
        const wb = { Sheets: { report: ws }, SheetNames: ['report'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
          data,
          `spare-inventory-report-${Date.now()}${fileExtension}`,
        );
      }
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading, locationsData, subLocationsData, sparePartTypeData } = this.props;
    const { selectedLocation, selectedSubLocation, selectedSparePart, selectedSparePartType } = this.state;
    const sparePartData = this.state.spareDatas || [];
    let inventories = this.props.inventories;


    if (this.state.hideZeroClosing) {
      inventories = inventories.filter(inv => parseFloat(inv.closeQty) !== 0);
    }
    if (this.state.hideZeroTransaction) {
      inventories = inventories.filter(inv => !(parseFloat(inv.inQty) === 0 && parseFloat(inv.outQty) === 0));
    }
    // console.log(`inventories:: `, inventories)
    const modalCols = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (date, record) => record.text === 'Opening Balance' ?
          moment(this.state.selectedFromDate).format('DD/MM/YYYY') : record.text === 'Closing Balance' ?
            moment(this.state.selectedToDate).format('DD/MM/YYYY') : moment(date).format('DD/MM/YYYY'),
      }, {
        title: 'Transaction Type',
        dataIndex: 'text',
        key: 'text',
      }, {
        title: 'Voucher',
        dataIndex: 'voucher',
        key: 'voucher',
        width: '150px',
        render: (_, record) => (
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Button size="small" type='link'
              onClick={() => this.handelVoucherClick(record.text, record.voucher)}>
              {record.voucher}
            </Button>
            {record.voucher && this.canTransferVoucher(record.text) && (
              <Icon
                type="edit"
                style={{ cursor: 'pointer', marginLeft: 8 }}
                onClick={() => this.handelTransferClick(record.text, record.voucher)}
              />
            )}
          </span>
        )
      }, {
        title: 'Asset',
        dataIndex: 'asset',
        key: 'asset',
        render: (_, record) => (<Button type={'link'}
          onClick={() => record.assetId && window.open(`/asset/history-report/${record.assetId}`, '_blank')}>{record.assetCode}</Button>)
      }].concat(commonCols);
    return (
      <div>
        <Spin spinning={loading}>
          <Card
            className={`gx-card-metrics`}
            title={`Spare Inventory Report`}
          >
            <Form
              onSubmit={this.handleSubmit}
              className="ant-advanced-search-form"
              layout="inline"
              labelAlign="left"
            >
              <Row gutter={8}>
                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                  <Form.Item
                    key={"periodFrom"}
                    label={"Select Period From"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`periodFrom`, {
                      rules: [
                        { required: true, message: `Period From is required!` }
                      ],
                      initialValue: null
                    })(<DatePicker onChange={value => this.handleSelect('periodFrom', value)}
                      style={{ width: "100%" }} />)}
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                  <Form.Item
                    key={"periodTo"}
                    label={"Select Period To"}
                    style={{ width: "100%" }}
                  >
                    {getFieldDecorator(`periodTo`, {
                      rules: [
                        { required: true, message: `Period To is required!` }
                      ],
                      initialValue: null
                    })(<DatePicker onChange={value => this.handleSelect('periodTo', value)}
                      style={{ width: "100%" }} />)}
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={7} xl={7}>

                  <Form.Item key={'sparePart'} label={'Enter Spare Part'} style={{ width: '100%' }}>
                    {getFieldDecorator(`sparePart`, {
                      rules: [{ required: true, message: `Spare Part is required!` }],
                      initialValue: ['All'],
                    })(<Select
                      showSearch
                      mode="multiple"
                      notFoundContent={this.state.spareFetching ? <Spin size="small" /> : null}
                      filterOption={false}
                      onSearch={this.fetchSpare}
                      onChange={value => this.handleSelect('sparePart', value)}
                      placeholder={`Please Enter Multiple Spare Part`}
                    >
                      <Select.Option key={'AllSparePart'}
                        disabled={selectedSparePart && !selectedSparePart.includes('All') && selectedSparePart.length > 0}
                        value={'All'}>All</Select.Option>

                      {(sparePartData || []).map(item =>
                        <Select.Option key={item._id}
                          disabled={selectedSparePart && selectedSparePart.includes('All')}
                          value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>

                </Col>

                <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                  {!sparePartTypeData ? <Spin size="small" /> : (
                    <Form.Item key={'sparePartType'} label={'Spare Part Type'} style={{ width: '100%' }}>
                      {getFieldDecorator(`sparePartType`, {
                        rules: [{ required: true, message: `Spare Part Type is required!` }],
                        initialValue: ['All'],
                      })(<Select
                        showSearch
                        showArrow
                        mode="multiple"
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        onChange={value => this.handleSelect('sparePartType', value)}
                        placeholder={`Please Select Multiple Spare Part Type`}
                      >
                        <Select.Option key={'AllSparePartType'}
                          disabled={selectedSparePartType && !selectedSparePartType.includes('All') && selectedSparePartType.length > 0}
                          value={'All'}>All</Select.Option>

                        {(sparePartTypeData.data || []).map(item =>
                          <Select.Option key={item._id}
                            disabled={selectedSparePartType && selectedSparePartType.includes('All')}
                            value={item._id}>{item.name}</Select.Option>)}
                      </Select>)
                      }
                    </Form.Item>
                  )}
                </Col>

                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                  {/* Location */
                  }
                  <Form.Item key={'location'} label={'Location'} style={{ width: '100%' }}>
                    {getFieldDecorator(`location`, {
                      rules: [{ required: true, message: `Location is required!` }],
                      initialValue: ['All'],
                    })(<Select
                      showSearch
                      showArrow
                      mode="multiple"
                      //onSelect={this.hideDownloadButton}
                      onChange={value => this.handleSelect('location', value)}
                      filterOption={(input, option) =>
                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                      }
                      placeholder={`Please Select Multiple Location`}
                    >
                      <Select.Option key={'AllLocation'}
                        disabled={selectedLocation && !selectedLocation.includes('All') && selectedLocation.length > 0}
                        value={'All'}>All</Select.Option>

                      {(locationsData.data || []).map(item =>
                        <Select.Option key={item._id}
                          disabled={selectedLocation && selectedLocation.includes('All')}
                          value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={5} xl={5}>

                  <Form.Item key={'subLocation'} label={'Sub Location'} style={{ width: '100%' }}>
                    {getFieldDecorator(`subLocation`, {
                      rules: [{ required: true, message: `Sub Location is required!` }],
                      initialValue: ['All'],
                    })(<Select
                      showSearch
                      showArrow
                      mode="multiple"
                      filterOption={(input, option) =>
                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                      }
                      onChange={value => this.handleSelect('subLocation', value)}
                      placeholder={`Please Select Multiple Sub Location`}
                    >
                      <Select.Option key={'AllSubLocation'}
                        disabled={selectedSubLocation && !selectedSubLocation.includes('All') && selectedSubLocation.length > 0}
                        value={'All'}>All</Select.Option>

                      {(subLocationsData.data || []).map(item =>
                        <Select.Option key={item._id}
                          disabled={selectedSubLocation && selectedSubLocation.includes('All')}
                          value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>
                </Col>

                <Col xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Form.Item key={"rate"} label={`Rate calculate on`}>
                    <Select defaultValue="avg" onChange={value => this.handleSelect('rate', value)}>
                      <Select.Option value="avg">AVG.</Select.Option>
                      <Select.Option value="lifo" disabled>LIFO</Select.Option>
                      <Select.Option value="fifo" disabled>FIFO</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={8}>
                <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                  <Form.Item key={"opening"} label={`Show Opening`}>
                    <MySwitch
                      checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />}
                      defaultChecked={this.state.showOpening}
                      onChange={value => this.handleSelect('opening', value)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                  <Form.Item key={"closing"} label={`Show Closing`}>
                    <MySwitch checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />}
                      defaultChecked={this.state.showClosing}
                      onChange={value => this.handleSelect('closing', value)} />
                  </Form.Item>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                  <Form.Item key={"zeroClose"} label={`Hide Zero Closing`}>
                    <MySwitch checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />}
                      defaultChecked={this.state.hideZeroClosing}
                      onChange={value => this.handleSelect('zeroClose', value)} />
                  </Form.Item>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                  <Form.Item key={"zeroTransaction"} label={`Hide Zero Transaction`}>
                    <MySwitch checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />}
                      defaultChecked={this.state.hideZeroTransaction}
                      onChange={value => this.handleSelect('zeroTransaction', value)} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={6} style={{ marginTop: 25 }}>
                  <Button type="primary" htmlType="submit" loading={loading || this.state.colLoading}>
                    Generate
                  </Button>
                  <Button icon='download' type="dashed" htmlType="button" disabled={!inventories || !inventories.length}
                    loading={loading || this.state.colLoading}
                    onClick={() => this.handleDownload(inventories)}>
                    Download
                  </Button>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6} style={{ marginTop: 25 }}>
                  <Button shape="round" type={'dashed'} onClick={() => this.handelMergeFormOpen()}
                    disabled={(!(this.props.mergeData && this.props.mergeData.length))}>
                    {'Merge - ' + (this.props.mergeData && this.props.mergeData.length || 0)}
                  </Button>
                </Col>
              </Row>
            </Form>

            <Table
              pagination={{ pageSize: 10 }} bordered
              loading={loading || this.state.colLoading}
              columns={this.state.reportColumns}
              dataSource={inventories}
              scroll={{ x: true }} size="small"
              rowClassName={(record) => record.color || ''}
              expandIconColumnIndex={3}
              // rowClassName={this.setRowClassName}
              onRow={this.onClickRow}
              rowSelection={this.rowSelection}
            // rowKey={(record) => Math.random() + (record.sparePartId || '') + new Date().getTime()}
            />

            <Modal
              style={{ top: 20 }}
              title="Details"
              visible={this.state.showDetails}
              onCancel={this.handleModalCancel}
              footer={null}
              width={'95%'}
              destroyOnClose={true}
            >
              <Descriptions bordered column={2}>
                <Descriptions.Item
                  label="From">{moment(this.state.selectedFromDate).format('DD/MM/YYYY')}</Descriptions.Item>
                <Descriptions.Item
                  label="To">{moment(this.state.selectedToDate).format('DD/MM/YYYY')}</Descriptions.Item>
                <Descriptions.Item
                  label="SparePart">{this.state.detailsSpare} /{this.state.detailsUnit}</Descriptions.Item>
                <Descriptions.Item
                  label="SparePart Type ">{this.state.detailsSpareType}</Descriptions.Item>
              </Descriptions>
              <Table
                bordered
                loading={loading}
                columns={modalCols}
                dataSource={this.state.detailsData}
                scroll={{ x: true }} size="small"
                rowClassName={(record) => record.color ? 'color-row' : ''}
              // expandIconColumnIndex={2}
              // rowClassName={this.setRowClassName}
              // onRow={this.onClickRow}
              />
            </Modal>
            <Modal
              title="SparePart Transfer"
              visible={this.state.showTransferModal}
              onOk={this.processTransfer}
              onCancel={this.cancelTransferModal}
              destroyOnClose={true}>
              <div>
                <p>Select Spare part for transfer</p>
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  showSearch
                  notFoundContent={this.state.spareFetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  onSearch={this.fetchSpare}
                  onChange={value => this.handleSelectTransferableSpare(value)}
                  placeholder={`Please Enter Spare Part to Transfer`}
                >
                  {(sparePartData || []).map(item =>
                    <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                </Select>
              </div>
            </Modal>
          </Card>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, spareInventoryReport, commonData, sparePart }) => {
  return {
    authUser: auth.authUser,
    // total: spareReport.total,
    inventories: spareInventoryReport.datas,
    locationsData: spareInventoryReport.locations,
    subLocationsData: spareInventoryReport.subLocations,
    sparePartTypeData: spareInventoryReport.sparePartTypes,
    // resource: spareReport.resource,
    loading: commonData.loading,
    // pageNo: spareReport.pageNo,
    mergeData: sparePart.mergeableSpares,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getSpareInventory,
    getSpareInventoryFilters,
    resetInventorySuccess,
    fetchVoucherByType,
    addToMergeList,
    addSpareListToMergeList,
    transferSpare,
  };
}

const SpareInventoryReport = Form.create({ name: 'spare-inventory' })(SpareInventory);
export default connect(mapStateToProps, mapDispatchToProps())(SpareInventoryReport);
